import 'highcharts/highcharts-more';
import 'highcharts/modules/solid-gauge';
import 'highcharts/modules/accessibility';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useMemo } from 'react';

import { Chart } from './utils';

import type { AcceptanceTimeItem } from '@/app/types/Dashboard';


interface Props {
	data: AcceptanceTimeItem;
}

const GougeAcceptanceTime = ({ data }: Props) => {
	const options = useMemo(() => {
		return Chart.toAcceptanceTimeOptions(data);
	}, [data]);

	return <HighchartsReact options={options} highcharts={Highcharts} />;
};

export default GougeAcceptanceTime;
